import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Grid } from 'coreOld/elements';

type InputWrapperProps = { children?: ReactNode };

export const InputWrapper = styled(Grid)<InputWrapperProps>`
  display: flex;
  align-items: center;
`;

type SignProps = { children?: ReactNode; bold?: boolean };

export const Sign = styled.div<SignProps>`
  margin-right: 15px;

  ${({ bold }) =>
    bold &&
    css`
      font-weight: 500;
    `}
`;

type TextProps = { children?: ReactNode };

export const Text = styled.div<TextProps>`
  font-weight: 500;
`;

type FieldsWrapperProps = { children?: ReactNode };

export const FieldsWrapper = styled(Grid)<FieldsWrapperProps>`
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};
  padding: 12px 30px;
`;

type WrapperProps = { children?: ReactNode };

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
`;

type ButtonWrapperProps = { children?: ReactNode };

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  align-self: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
`;

type BtnWrapperProps = { children?: ReactNode };

export const BtnWrapper = styled.div<BtnWrapperProps>`
  width: 100%;
  padding: 10px 30px;
  display: flex;
  flex-direction: column;
`;

type ListProps = { children?: ReactNode };

export const List = styled.div<ListProps>`
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
`;

type ListWrapperProps = { children?: ReactNode };

export const ListWrapper = styled.div<ListWrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};
  padding: 20px 30px;
`;

type RemoveBtnProps = { children?: ReactNode };

export const RemoveBtn = styled.div<RemoveBtnProps>`
  margin-top: 10px;
`;

type BottomBtnWrapperProps = { children?: ReactNode };

export const BottomBtnWrapper = styled.div<BottomBtnWrapperProps>`
  border-top: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};
  padding: 5px 30px 10px 30px;
`;
